<template>
  <div
    class="rounded-xl bg-linear-to-br from-brand/50 via-transparent to-brand/50 p-px"
  >
    <div class="relative overflow-hidden rounded-xl bg-depth-1">
      <!-- Background image -->
      <img
        v-if="component.customComponent?.backgroundImage"
        :src="component.customComponent.backgroundImage.url"
        :alt="
          component.customComponent.backgroundImage.alternativeText ||
          component.customComponent.title
        "
        class="absolute inset-0 h-full w-full object-cover opacity-20"
      />
      <div
        class="pointer-events-none absolute -top-10 -right-10 z-0 h-40 w-56 rounded-full bg-brand/10 mix-blend-screen blur-3xl"
      ></div>

      <!-- Content -->
      <div class="relative p-5 sm:p-6 md:p-8">
        <h3 class="text-lg font-semibold text-mouse sm:text-xl">
          {{ component.customComponent.title }}
        </h3>
        <div
          v-if="component.customComponent.content"
          class="mt-2 text-sm leading-relaxed text-rhino sm:text-base prose prose-invert prose-sm max-w-none"
          v-html="renderedContent"
        ></div>
        <div
          v-if="component.customComponent.buttons?.length"
          class="mt-4 flex flex-wrap gap-3"
        >
          <a
            v-for="btn in component.customComponent.buttons"
            :key="btn.id"
            :href="btn.link"
            :target="btn.newTab ? '_blank' : '_self'"
            :rel="btn.newTab ? 'noopener noreferrer' : undefined"
            class="inline-block rounded-md px-4 py-1.5 text-sm font-semibold no-underline transition-colors hover:no-underline"
            :class="
              btn.type === 'primary'
                ? 'bg-brand text-onyx hover:bg-brand/90'
                : 'border border-mouse/20 bg-depth-3 text-mouse hover:bg-depth-3/80'
            "
          >
            {{ btn.text }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiCustomComponent } from '~/apollo/types/types';

const props = defineProps({
  component: {
    type: Object as PropType<StrapiCustomComponent>,
    required: true,
  },
});

const md = useMarkdownIt();
const renderedContent = computed(() => {
  const content = props.component.customComponent?.content;
  return content ? md.render(content) : '';
});
</script>
